module.exports = __webpack_public_path__ + "img/5.f5753ac7.jpg";